
  export default {
    props: {
      features: { type: Array, default () { return []; } }
    },
    methods: {
      tooltipOptions (feature) {
        if (!feature.description) {
          return null;
        }
        let opts = { classes: 'listItemTooltip', content: feature.description };
        if (!this.$store.getters['utils/isTablet']) {
          opts.trigger = 'click';
        }
        return opts;
      }
    }
  };
